import { Box } from "@mui/material";
import BreakdownBars from "../components/BreakdownBars";
import Card, { CardGrid } from "../components/Card";
import KpiTile from "../components/KpiTile";
import SeriesChart from "../components/SeriesChart";
import StatsGate from "../components/StatsGate";
import { formatDuration, formatPercent } from "../format";
import { SecondScreen, TabProps } from "../types";
import { useStats } from "../useStats";

export default function SecondScreenTab({ query, reloadKey }: TabProps) {
  const state = useStats<SecondScreen>("/second-screen", query, reloadKey);
  return (
    <StatsGate state={state}>
      {(data, envelope) => (
        <>
          <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, mb: 2 }}>
            <KpiTile label="Sessions" value={data.sessions} />
            <KpiTile label="Paired" value={data.pairingRate} format={formatPercent} />
            <KpiTile label="Median time to pair" value={data.medianSecondsToPair} format={formatDuration} />
            <KpiTile label="Sessions with a wrong PIN" value={data.pinFailures.sessions} />
            <KpiTile label="Wrong PIN attempts" value={data.pinFailures.attempts} />
            <KpiTile label="Expired before pairing" value={data.expiredUnpaired} />
          </Box>
          <CardGrid>
            <Card title="Sessions started" wide>
              <SeriesChart points={data.series} bucket={envelope.filters.bucket ?? "day"} lines={[{ key: "sessions", label: "Sessions" }]} />
            </Card>
            <Card title="By state"><BreakdownBars rows={data.byState} /></Card>
            <Card title="Why sessions ended"><BreakdownBars rows={data.revokeReasons} /></Card>
          </CardGrid>
        </>
      )}
    </StatsGate>
  );
}
